import React, { useContext, useEffect, useState } from "react";
import { IdentityContext } from "../../contexts/IdentityProvider";
import axios from "axios";
import { Card, Icon, Typography, FlexBox } from "@vp/swan";
import { DebugServiceLineItem } from "./DebugServiceLineItem";

export interface DebugServiceWithTokenProps {
  url: string;
}

export const DebugServiceWithToken = (props: DebugServiceWithTokenProps) => {
  const { url } = props;
  const { auth } = useContext(IdentityContext);
  const authorizationHeader = auth?.getAuthorizationHeader();
  const [response, setResponse] = useState<any>(undefined);
  const [showResponse, setShowResponse] = useState(false);
  const path = url?.split("?")?.[0];

  useEffect(() => {
    let mounted = true;

    const callService = async () => {
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: authorizationHeader,
          },
        });

        if (mounted && response && response.data) {
          setResponse(response.data);
        }
      } catch (e) {
        if (mounted) {
          const display = {
            message: (e as any)?.message,
            status: (e as any)?.response?.status,
            name: (e as any)?.name,
            url: (e as any)?.config?.url,
          };
          setResponse(display);
        }
      }
    };
    callService();

    return () => {
      mounted = false;
    };
  }, []);

  const toggleShowRepsonse = () => {
    setShowResponse(!showResponse);
  };

  if (response) {
    return (
      <Card>
        <FlexBox onClick={toggleShowRepsonse}>
          <Icon iconType={showResponse ? "minus" : "plus"} mr={"5"} />
          <Typography fontSize={"xsmall"}>{path}</Typography>
        </FlexBox>
        {showResponse && (
          <Typography fontSize={"xsmall"}>
            <pre>
              <code style={{ whiteSpace: "break-spaces" }}>
                {JSON.stringify({ response }, null, 2)}
              </code>
            </pre>
          </Typography>
        )}
      </Card>
    );
  }

  return <DebugServiceLineItem url={url} />;
};
